/* Quiz "Quelle radio vous ressemble ?" - A.bsolument
   Vanilla JS, aucune dépendance. Klaviyo : client API publique uniquement (company ID),
   jamais de clé privée ici. Les données externes (products.json) sont rendues via
   createElement/textContent ; le reste du markup vient de constantes internes. */
(function () {
  'use strict';

  var root = document.querySelector('[data-quiz]');
  var cfgEl = document.querySelector('[data-quiz-config]');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var QUESTIONS = [
    { q: 'Où vivra-t-elle ?', options: [
      { label: 'Sur le buffet du salon, bien en vue', pts: { salon: 3, pepite: 1 } },
      { label: "Au sol : c'est elle, le meuble", pts: { meuble: 4 } },
      { label: 'Un peu partout : cuisine, bureau, terrasse aux beaux jours', pts: { nomade: 3 } },
      { label: 'Dans une pièce qui a du caractère : atelier, loft, bureau', pts: { boombox: 3, nomade: 1 } }
    ] },
    { q: "Quelle époque vous fait de l'oeil ?", options: [
      { label: "Les années 30-40 : TSF, bois sombre, élégance d'avant-guerre", pts: { salon: 3, meuble: 2 }, decade: '30-40' },
      { label: 'Les années 50-60 : formes douces, cadrans dorés, bakélite', pts: { salon: 3, meuble: 1 }, decade: '50-60' },
      { label: 'Les années 70 : pop, compact, coloré', pts: { nomade: 3 }, decade: '70' },
      { label: 'Les années 80 : chrome, cassettes, premiers sons urbains', pts: { boombox: 3 }, decade: '80' },
      { label: "Peu importe l'époque : je cherche la pièce d'exception", pts: { pepite: 3 }, decade: null }
    ] },
    { q: "Votre moment d'écoute idéal ?", options: [
      { label: "Un dîner qui s'étire, du jazz en fond sonore", pts: { salon: 2, meuble: 1 } },
      { label: 'En cuisinant, en bricolant : la musique me suit', pts: { nomade: 3 } },
      { label: "Au calme, attentivement : le son d'abord", pts: { pepite: 3 } },
      { label: 'Volume généreux quand la maison est à moi', pts: { boombox: 2, meuble: 1 } }
    ] },
    { q: 'Une radio vintage chez vous, ce serait avant tout...', options: [
      { label: 'Une histoire : un objet qui a vécu et continue de vivre', pts: { salon: 2, meuble: 1 } },
      { label: "Une rareté : la pièce que personne d'autre n'aura", pts: { pepite: 3 } },
      { label: 'Une liberté : elle me suit, sans fil à la patte', pts: { nomade: 2 } },
      { label: 'Une affirmation : du caractère, assumé', pts: { boombox: 2 } }
    ] },
    { q: 'Et côté son, vous êtes plutôt...', options: [
      { label: 'Chaleureux, enveloppant : il habille la pièce', pts: { salon: 2, meuble: 2 } },
      { label: 'Précis, fidèle : chaque détail compte', pts: { pepite: 3 } },
      { label: 'Du punch, des basses qui se sentent', pts: { boombox: 3 } },
      { label: 'Du bon son, simplement, partout où je suis', pts: { nomade: 3 } }
    ] }
  ];

  var GAMMES = {
    salon: {
      name: 'La radio de salon des années 30-60',
      pitch: "Bois massif, cadran à aiguilles, le poste qu'on allumait pour les grandes occasions. C'est la pièce qui a fait la réputation de l'atelier : nous en avons restauré plus que toutes les autres réunies. Posée sur un buffet, elle attire la main et les questions. Le son Focal fait le reste."
    },
    nomade: {
      name: 'Le transistor des années 70',
      pitch: "Compact, coloré, et il vous suit partout : douze heures de batterie, du bon son sans prise ni contrainte. Les seventies avaient le sens de la ligne. Celui-ci a déjà vécu une première vie, on lui a simplement rendu la parole, en Bluetooth."
    },
    boombox: {
      name: 'La boombox des années 80',
      pitch: "Chrome, double cassette, et cette présence qui ne demande pas la permission. La boombox, c'est l'adolescence de toute une génération, remise au son d'aujourd'hui, basses comprises. Nous en restaurons peu : quand il y en a une à l'atelier, elle ne reste jamais longtemps."
    },
    meuble: {
      name: 'Le meuble radio',
      pitch: "Celui-là ne se pose pas sur un meuble : c'est lui, le meuble. Ébénisterie d'époque, façade en tissu d'origine, un son qui prend la pièce entière. Nos clients le décrivent toujours pareil : la plus belle pièce du salon."
    },
    pepite: {
      name: 'La Pépite',
      pitch: "Les Pépites, ce sont les modèles qu'on ne croise qu'une fois : marques disparues, séries confidentielles, états de conservation rares. Nous leur réservons le meilleur, le haut-parleur Focal Flax. Pour ceux qui ne cherchent pas une radio, mais la radio."
    }
  };

  var TIE_ORDER = ['salon', 'pepite', 'nomade', 'meuble', 'boombox'];
  var LETTERS = ['A', 'B', 'C', 'D', 'E'];
  var DECADE_RANGES = { '30-40': [1925, 1949], '50-60': [1950, 1969], '70': [1970, 1979], '80': [1980, 1989] };

  var screens = {
    intro: root.querySelector('[data-screen="intro"]'),
    question: root.querySelector('[data-screen="question"]'),
    result: root.querySelector('[data-screen="result"]')
  };
  var qTitle = root.querySelector('[data-question]');
  var qOptions = root.querySelector('[data-options]');
  var qBack = root.querySelector('[data-back]');
  var qBar = root.querySelector('[data-bar]');
  var qBarFill = root.querySelector('[data-bar-fill]');
  var qLabel = root.querySelector('[data-progress-label]');

  var state = { step: 0, answers: [null, null, null, null, null], result: null, decade: null, started: false };

  /* ---------- tracking ---------- */

  function track(name, props) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', name, props || {}]);
    } catch (e) { /* silencieux */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name.toLowerCase().replace(/\s+/g, '_') }, props || {}));
    } catch (e) { /* silencieux */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, props || {});
      }
    } catch (e) { /* silencieux */ }
  }

  function klaviyoSubscribe(email, firstName, props) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Quiz Radio',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                properties: props
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: CFG.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
      body: JSON.stringify(body)
    });
  }

  function klaviyoEvent(name, email, props) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: props || {},
          metric: { data: { type: 'metric', attributes: { name: name } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
      body: JSON.stringify(body)
    });
  }

  /* ---------- helpers DOM ---------- */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function formatPrice(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    var opts = n % 1 === 0 ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return n.toLocaleString('fr-FR', opts) + ' €';
  }

  function imgResize(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function show(name) {
    Object.keys(screens).forEach(function (k) {
      if (screens[k]) screens[k].hidden = (k !== name);
    });
    try { window.scrollTo({ top: root.offsetTop > 90 ? root.offsetTop - 90 : 0 }); } catch (e) { /* vieux navigateurs */ }
  }

  function computeResult() {
    var scores = { salon: 0, nomade: 0, boombox: 0, meuble: 0, pepite: 0 };
    state.answers.forEach(function (ans, i) {
      if (ans == null) return;
      var pts = QUESTIONS[i].options[ans].pts;
      Object.keys(pts).forEach(function (g) { scores[g] += pts[g]; });
    });
    var best = TIE_ORDER[0];
    TIE_ORDER.forEach(function (g) { if (scores[g] > scores[best]) best = g; });
    var decade = state.answers[1] != null ? (QUESTIONS[1].options[state.answers[1]].decade || null) : null;
    return { gamme: best, scores: scores, decade: decade };
  }

  /* ---------- écrans ---------- */

  function renderQuestion() {
    var i = state.step;
    var question = QUESTIONS[i];
    qLabel.textContent = 'Question ' + (i + 1) + ' sur 5';
    qBar.setAttribute('aria-valuenow', String(i + 1));
    qBarFill.style.width = ((i + 1) * 20) + '%';
    qTitle.textContent = question.q;
    while (qOptions.firstChild) qOptions.removeChild(qOptions.firstChild);
    question.options.forEach(function (opt, idx) {
      var b = el('button', 'abs-quiz__option', opt.label);
      b.type = 'button';
      if (state.answers[i] === idx) b.style.borderColor = '#C75B39';
      b.addEventListener('click', function () { answer(idx); });
      qOptions.appendChild(b);
    });
    qBack.hidden = (i === 0);
    show('question');
    qTitle.focus();
  }

  function answer(idx) {
    state.answers[state.step] = idx;
    track('Quiz Step Completed', {
      step: state.step + 1,
      question: QUESTIONS[state.step].q,
      answer: LETTERS[idx]
    });
    if (state.step < QUESTIONS.length - 1) {
      state.step += 1;
      renderQuestion();
    } else {
      renderResult();
    }
  }

  function answersString() {
    return state.answers.map(function (a) { return a == null ? '-' : LETTERS[a]; }).join(',');
  }

  function buildCaptureBox() {
    var box = el('div', 'abs-quiz__capture');
    box.setAttribute('data-capture-box', '');

    box.appendChild(el('h3', 'abs-quiz__capture-title', '10 % de bienvenue sur votre première pièce'));
    box.appendChild(el('p', 'abs-quiz__capture-text', "Laissez votre email : votre code personnel arrive tout de suite, avec votre sélection et les prochaines pièces de votre gamme en avant-première."));
    box.appendChild(el('p', 'abs-quiz__rarete', 'Chaque radio est une pièce unique : une fois partie, elle ne revient pas.'));

    var form = el('form', 'abs-quiz__form');
    form.setAttribute('data-capture', '');
    form.noValidate = true;

    var inFirst = el('input', 'abs-quiz__input');
    inFirst.type = 'text'; inFirst.name = 'first_name'; inFirst.required = true;
    inFirst.placeholder = 'Votre prénom'; inFirst.autocomplete = 'given-name';
    inFirst.setAttribute('aria-label', 'Votre prénom');

    var inMail = el('input', 'abs-quiz__input');
    inMail.type = 'email'; inMail.name = 'email'; inMail.required = true;
    inMail.placeholder = 'Votre email'; inMail.autocomplete = 'email';
    inMail.setAttribute('aria-label', 'Votre email');

    var submit = el('button', 'abs-quiz__btn', 'Recevoir mon code -10 %');
    submit.type = 'submit';

    var err = el('p', 'abs-quiz__error');
    err.setAttribute('role', 'alert');
    err.setAttribute('data-error', '');
    err.hidden = true;

    form.appendChild(inFirst);
    form.appendChild(inMail);
    form.appendChild(submit);
    form.appendChild(err);
    form.addEventListener('submit', onSubmit);
    box.appendChild(form);

    return box;
  }

  function buildProductsZone(collUrl) {
    var zone = el('div');
    zone.setAttribute('data-products-zone', '');
    zone.hidden = true;

    zone.appendChild(el('h3', 'abs-quiz__products-title', "Actuellement à l'atelier"));

    var note = el('p', 'abs-quiz__products-note');
    note.setAttribute('data-products-note', '');
    note.hidden = true;
    zone.appendChild(note);

    var grid = el('div', 'abs-quiz__grid');
    grid.setAttribute('data-grid', '');
    zone.appendChild(grid);

    var linkWrap = el('div', 'abs-quiz__coll-link');
    var collLink = el('a', 'abs-quiz__btn', 'Voir toute la collection');
    collLink.href = collUrl;
    linkWrap.appendChild(collLink);
    zone.appendChild(linkWrap);

    return zone;
  }

  function renderResult() {
    var res = computeResult();
    state.result = res.gamme;
    state.decade = res.decade;
    var g = GAMMES[res.gamme];
    var meta = CFG.gammes[res.gamme] || {};
    var collUrl = meta.url || (CFG.fallback && CFG.fallback.url) || '/collections/toutes-les-radios';
    track('Quiz Completed', { gamme: res.gamme, gamme_nom: g.name, decennie: res.decade || '', reponses: answersString() });

    var scr = screens.result;
    while (scr.firstChild) scr.removeChild(scr.firstChild);

    scr.appendChild(el('p', 'abs-quiz__kicker', 'Votre résultat'));

    var title = el('h2', 'abs-quiz__title', g.name);
    title.setAttribute('tabindex', '-1');
    scr.appendChild(title);

    if (meta.image) {
      var img = el('img', 'abs-quiz__reveal-img');
      img.src = meta.image;
      img.alt = g.name;
      img.width = 1200; img.height = 800;
      scr.appendChild(img);
    }

    scr.appendChild(el('p', 'abs-quiz__pitch', g.pitch));
    scr.appendChild(buildCaptureBox());
    scr.appendChild(buildProductsZone(collUrl));

    show('result');
    title.focus();
    loadProducts(res.gamme, res.decade);
  }

  /* ---------- produits ---------- */

  function fetchAvailable(handle, excludeIds) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=48')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return (d.products || []).filter(function (p) {
          var ok = (p.variants || []).some(function (v) { return v.available; });
          if (!ok) return false;
          return !excludeIds || excludeIds.indexOf(p.id) === -1;
        });
      });
  }

  function productYear(p) {
    var m = (p.title || '').match(/(19[2-9][0-9])\b/);
    return m ? parseInt(m[1], 10) : null;
  }

  function sortByDecade(items, decade) {
    var range = decade && DECADE_RANGES[decade];
    if (!range) return items;
    return items.slice().sort(function (a, b) {
      var ya = productYear(a);
      var yb = productYear(b);
      var ia = (ya !== null && ya >= range[0] && ya <= range[1]) ? 0 : 1;
      var ib = (yb !== null && yb >= range[0] && yb <= range[1]) ? 0 : 1;
      return ia - ib;
    });
  }

  function buildCard(p) {
    var card = el('a', 'abs-quiz__card');
    card.href = '/products/' + encodeURIComponent(p.handle);

    var imgSrc = (p.images && p.images[0] && p.images[0].src) || '';
    if (imgSrc) {
      var img = el('img', 'abs-quiz__card-img');
      img.src = imgResize(imgSrc, 480);
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 480; img.height = 480;
      card.appendChild(img);
    } else {
      card.appendChild(el('span', 'abs-quiz__card-img'));
    }

    var body = el('span', 'abs-quiz__card-body');
    body.appendChild(el('span', 'abs-quiz__card-title', p.title || ''));
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    body.appendChild(el('span', 'abs-quiz__card-price', formatPrice(v.price)));
    card.appendChild(body);
    return card;
  }

  function loadProducts(gamme, decade) {
    var meta = CFG.gammes[gamme] || {};
    var zone = screens.result.querySelector('[data-products-zone]');
    var grid = screens.result.querySelector('[data-grid]');
    var note = screens.result.querySelector('[data-products-note]');
    if (!zone || !grid) return;

    fetchAvailable(meta.handle)
      .then(function (own) {
        var picked = sortByDecade(own, decade).slice(0, 3);
        if (picked.length >= 3 || !CFG.fallback || CFG.fallback.handle === meta.handle) {
          return { items: picked, completed: false };
        }
        var ids = picked.map(function (p) { return p.id; });
        return fetchAvailable(CFG.fallback.handle, ids).then(function (others) {
          return { items: picked.concat(sortByDecade(others, decade).slice(0, 3 - picked.length)), completed: others.length > 0 && picked.length < 3 };
        });
      })
      .then(function (r) {
        if (!r.items.length) return; // rien à montrer, la zone reste cachée
        r.items.forEach(function (p) { grid.appendChild(buildCard(p)); });
        if (r.completed && note) {
          note.textContent = "Les pièces de cette gamme partent vite : voici aussi d'autres radios actuellement à l'atelier.";
          note.hidden = false;
        }
        zone.hidden = false;
      })
      .catch(function () { /* zone produits cachée en cas d'échec réseau */ });
  }

  /* ---------- capture ---------- */

  function onSubmit(ev) {
    ev.preventDefault();
    var form = ev.currentTarget;
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('button[type="submit"]');
    var firstName = (form.first_name.value || '').trim();
    var email = (form.email.value || '').trim();

    errEl.hidden = true;
    if (!firstName) { errEl.textContent = 'Dites-nous votre prénom.'; errEl.hidden = false; form.first_name.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { errEl.textContent = 'Cet email ne semble pas valide.'; errEl.hidden = false; form.email.focus(); return; }

    btn.disabled = true;
    btn.textContent = 'Envoi en cours...';

    var props = {
      quiz_result: state.result,
      quiz_answers: answersString(),
      quiz_decade: state.decade || '',
      quiz_date: new Date().toISOString().slice(0, 10),
      lang: 'fr'
    };

    klaviyoSubscribe(email, firstName, props)
      .then(function (resp) {
        if (!resp.ok) throw new Error('subscribe ' + resp.status);
        try { localStorage.setItem('abs_subscriber', '1'); } catch (e) { /* navigation privée */ }
        klaviyoEvent('Quiz Email Captured', email, {
          gamme: state.result,
          gamme_nom: GAMMES[state.result].name,
          decennie: state.decade || '',
          reponses: answersString()
        }).catch(function () { /* non bloquant */ });
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'quiz_lead', quiz_gamme: state.result }); } catch (e) { /* silencieux */ }

        var box = screens.result.querySelector('[data-capture-box]');
        while (box.firstChild) box.removeChild(box.firstChild);
        var sent = el('p', 'abs-quiz__sent');
        sent.appendChild(el('strong', null, "C'est envoyé."));
        sent.appendChild(document.createElement('br'));
        sent.appendChild(document.createTextNode('Votre code -10 % et votre sélection arrivent dans votre boîte mail.'));
        box.appendChild(sent);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Recevoir mon code -10 %';
        errEl.textContent = "L'envoi n'a pas abouti. Vérifiez votre email et réessayez.";
        errEl.hidden = false;
      });
  }

  /* ---------- init ---------- */

  root.querySelector('[data-start]').addEventListener('click', function () {
    if (!state.started) {
      state.started = true;
      track('Quiz Started', {});
    }
    state.step = 0;
    renderQuestion();
  });

  qBack.addEventListener('click', function () {
    if (state.step > 0) {
      state.step -= 1;
      renderQuestion();
    }
  });
})();
